module.exports = __webpack_public_path__ + "img/back_100.ba095933.jpg";